export default __webpack_public_path__ + "static/header-title-dont-light-2c1a37b9a112a70678f7cd516bbe9736d0dda9c20a69b2aaf7a2387dcb8df9cc.png";